// extracted by mini-css-extract-plugin
export default {"contentLayout":"SimpleLayout_contentLayout__izhQr","domainDisplay":"SimpleLayout_domainDisplay__3d8VP","relatedLinks":"SimpleLayout_relatedLinks__QZ7Cs"};